import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  modal: {
    maxWidth: 580
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  mainLabel: {
    marginTop: theme.spacing(2),
    fontSize: 38
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(3),
    backgroundColor: theme.colorPalette.beige_25,
    borderRadius: theme.sizes.roundCorners
  },
  errorText: {
    color: theme.colors.error
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4)
  },
  buttons: {
    padding: theme.spacing(0, 7)
  }
});

export default makeStyles(styles);
